import { useState } from "react";
import Presentation from "./presentation";

const component =  ( { handleSettingsOpen, handleMarkAllRead } ) => {

	const [ anchorEl, setAnchorEl ] = useState ( null );
	const [ open, setOpen ]         = useState ( false );

	const handleClickOpen = async event => {
		if ( !open ) {
			setAnchorEl ( event.currentTarget );
			setOpen ( previousOpen => !previousOpen );

		}
	  };

	  const toggleMenuDialog = () => {
		setOpen ( previousOpen => !previousOpen );
	  };

	return (
		<Presentation
			anchorEl           = { anchorEl }
			handleMarkAllRead  = { handleMarkAllRead }
			handleOpen         = { handleClickOpen }
			handleSettingsOpen = { handleSettingsOpen }
			open               = { open }
			toggleMenuDialog   = { toggleMenuDialog }
		/>

	);
};

export default component;
